/* Reference In Time fixes — updated 18 Aug 2026
   0) On desktop widths the header search bar is relocated to sit
      beside the cart icon (and moved back for mobile widths).
   1) Short product titles on mobile: "Year Brand Series Reference".
      Store titles follow "Year Brand Series [descriptors] <size>mm
      Material(s) Reference", so everything from the size token up to
      (but not including) the final reference token is dropped. Titles
      without a size token (straps, jewelry) are left untouched.
   2) SOLD badge on any product card that lacks one — the Globo
      Smart Product Filter renders cards without the theme's sold
      badge on collection and search pages; the theme's own cards
      already include it.
   3) Sold products demoted to the end of each rendered product grid
      (collection pages, search results, Globo grids). In-stock items
      keep their order; sold items follow, per rendered page.
   4) When Globo replaces the search grid it prints its own product
      count, so the theme's results line is hidden to avoid showing
      two different numbers.
   Runs on page load, after every Globo render, and on DOM changes.
   Every step is idempotent, so the MutationObserver settles after
   one pass. */
(function () {
  'use strict';

  /* ---------- 0) header search beside the cart (desktop) ---------- */
  var headerMQ = window.matchMedia ? window.matchMedia('(min-width: 981px)') : null;

  function placeHeaderSearch() {
    var identity = document.querySelector('header.theme-header #identity');
    if (!identity) return;
    var ls = identity.querySelector('.large-search');
    var cart = identity.querySelector('.cart--container');
    var logo = identity.querySelector('#logo');
    if (!ls || !cart) return;
    var wide = headerMQ ? headerMQ.matches : false;
    if (wide) {
      if (!cart.contains(ls)) cart.insertBefore(ls, cart.firstChild);
      document.documentElement.classList.add('rit-search-right');
    } else {
      if (cart.contains(ls)) identity.insertBefore(ls, logo || cart);
      document.documentElement.classList.remove('rit-search-right');
    }
  }
  if (headerMQ) {
    if (headerMQ.addEventListener) { headerMQ.addEventListener('change', placeHeaderSearch); }
    else if (headerMQ.addListener) { headerMQ.addListener(placeHeaderSearch); }
  }

  /* ---------- 1) title shortener ---------- */
  var MM_RE = /^\d+(?:\.\d+)?mm$/i;
  var NUM_RE = /^\d+(?:\.\d+)?$/;
  var X_RE = /^[x\u00d7]$/i;
  var STOP = { SINGLE: 1, DOUBLE: 1, SEALED: 1, NEW: 1, OLD: 1, STOCK: 1, UNWORN: 1, NOS: 1 };

  function shorten(title) {
    var t = title.trim().split(/\s+/);
    if (t.length < 5) return null;
    var mm = -1;
    for (var i = 2; i < t.length - 1; i++) {
      if (MM_RE.test(t[i])) { mm = i; break; }
    }
    if (mm === -1) return null;
    var cut = mm;
    /* handle dual dimensions like "23 x 30mm" */
    if (cut > 3 && X_RE.test(t[cut - 1]) && NUM_RE.test(t[cut - 2])) cut -= 2;
    var head = [];
    for (var j = 0; j < cut; j++) {
      var w = t[j];
      /* drop all-caps marketing tokens (SINGLE SEALED, NEW OLD STOCK) */
      if (j > 0 && w.length > 2 && w === w.toUpperCase() && STOP[w] === 1) continue;
      head.push(w);
    }
    head.push(t[t.length - 1]);
    var s = head.join(' ');
    return s === title ? null : s;
  }

  function shortenTitles() {
    var nodes = document.querySelectorAll('.product--listing-title:not(.rit-title-processed)');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var full = (el.textContent || '').trim();
      el.classList.add('rit-title-processed');
      var short = shorten(full);
      if (!short) continue;
      el.textContent = '';
      var a = document.createElement('span');
      a.className = 'rit-title-full';
      a.textContent = full;
      var b = document.createElement('span');
      b.className = 'rit-title-short';
      b.textContent = short;
      el.appendChild(a);
      el.appendChild(b);
    }
  }

  /* ---------- shared ---------- */
  function isSold(card) {
    return !!card.querySelector('.price--sold-out, .icn.so, .so.icn');
  }

  /* ---------- 2) SOLD badge ---------- */
  function addBadges() {
    var cards = document.querySelectorAll('.product-index:not(.rit-badge-checked), .collection__page-product:not(.rit-badge-checked)');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      card.classList.add('rit-badge-checked');
      if (card.closest('#predictive-search')) continue;
      if (!card.querySelector('.price--sold-out')) continue;
      if (card.querySelector('.icn.so, .so.icn')) continue;
      var host = card.querySelector('.prod-container') || card;
      var badge = document.createElement('div');
      badge.className = 'so icn rit-sold-badge';
      badge.textContent = 'Sold';
      host.insertBefore(badge, host.firstChild);
    }
  }

  /* ---------- 3) demote sold cards to end of grid ---------- */
  var GRID_SELECTOR = '.collection__page-products, .search_section-grid--wrapper, #gf-products, .gf_products';

  function isCard(el) {
    if (el.nodeType !== 1) return false;
    if (el.classList.contains('product-index') || el.classList.contains('collection__page-product')) return true;
    return !!el.querySelector('.prod-container, .price--listing');
  }

  function demoteSold() {
    var grids = document.querySelectorAll(GRID_SELECTOR);
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      if (grid.closest('.flickity-enabled, .slick-initialized, #predictive-search')) continue;
      var cards = [];
      for (var i = 0; i < grid.children.length; i++) {
        if (isCard(grid.children[i])) cards.push(grid.children[i]);
      }
      if (cards.length < 2) continue;
      /* only touch the DOM when an in-stock card sits after a sold one */
      var needs = false, seenSold = false;
      for (var c = 0; c < cards.length; c++) {
        if (isSold(cards[c])) { seenSold = true; }
        else if (seenSold) { needs = true; break; }
      }
      if (!needs) continue;
      var frag = document.createDocumentFragment();
      for (var s = 0; s < cards.length; s++) {
        if (isSold(cards[s])) frag.appendChild(cards[s]);
      }
      grid.appendChild(frag);
    }
  }

  /* ---------- 4) avoid double result counts on /search ---------- */
  function tidySearchMeta() {
    var meta = document.querySelector('.rit-search-meta');
    if (meta && meta.style.display !== 'none' && document.getElementById('gf-products')) {
      meta.style.display = 'none';
    }
  }

  /* ---------- run pipeline ---------- */
  function run() {
    placeHeaderSearch();
    shortenTitles();
    addBadges();
    demoteSold();
    tidySearchMeta();
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('globoFilterRenderCompleted', schedule);
  function observe() {
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.body) { observe(); } else { document.addEventListener('DOMContentLoaded', observe); }
})();
